export default function appendSnsBtns() {
  // line
  const {title} = document;
  const linecode = `<li class='lineBox'><a href='https://line.me/R/msg/text/?${  title  }  ${  window.location.href  }' class='p_snsIcon isLine'></a></li>`
  setTimeout(() => { $("#jsShare").append(linecode) }, 2000);
    
  // twiter
  const twittercode = `<li class='twBox'><a href='twitter://post?message=${  title  }${window.location.href  }&via=activo_npo' data-lang='ja' class='p_snsIcon isTwitter'></a></li>`
  setTimeout(() => { $("#jsShare").append(twittercode) }, 2000);

  // facebook
  const facebookcode = `<li class='fbBox'><a class='jsFacebookTemporary p_snsIcon isFacebook' target='_blank' href='https://www.facebook.com/share.php?u=${  window.location.href  }' ></a></li>`
  setTimeout(() => { $("#jsShare").append(facebookcode) }, 2000);
}